import React, { Component } from 'react'
import ConfiguratorSection from '../ConfiguratorSection'
import ConfiguratorImage from '../ConfiguratorImage'
import ConfiguratorOption from '../ConfiguratorOption'
import { withTranslation, Trans } from 'react-i18next'
import { interiorView08ImageOptions } from './views/InteriorView08'

class Xr41Head extends Component {
  render () {
    let imageOptions = interiorView08ImageOptions

    let image = (
      <ConfiguratorImage
        boat='Xr41'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Head' />
          </h1>

          <p>
            <Trans defaults='The head is spacious with a sink, manually flushed toilet, shower sump pump and freeboard cupboard for utilities.' />
          </p>

          <p>
            <Trans defaults='A hot-water shower installation can be added together with the hotwater system and cockpit shower.' />
          </p>
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41Head)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41Head.js